import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import FullNameInput from 'ui-addon-i18n/components/FullNameInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Form } from 'foundations-components/transitional/components/Form';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { H1 } from 'foundations-components/transitional/components/H1';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class BlankNameModal extends Component {
  render() {
    const {
      stagedFirstName,
      stagedLastName,
      validFirstName,
      validLastName
    } = this.props;
    return /*#__PURE__*/_jsxs(Modal, {
      size: "auto",
      use: "conversational",
      children: [/*#__PURE__*/_jsx(DialogHeader, {
        children: /*#__PURE__*/_jsx(H1, {
          children: I18n.text('userPreferences.labels.whatsYourName')
        })
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx(Form, {
          children: /*#__PURE__*/_jsx(FullNameInput, {
            givenNameInput: /*#__PURE__*/_jsx(FormControl
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            , {
              error: stagedFirstName && !validFirstName,
              validationMessage: stagedFirstName && !validFirstName && I18n.text('userPreferences.labels.invalidName'),
              children: /*#__PURE__*/_jsx(TextInput, {
                "data-test-id": "blank-first-name",
                value: stagedFirstName,
                onChange: this.props.onStagedFirstNameChanged
              })
            }),
            familyNameInput: /*#__PURE__*/_jsx(FormControl
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            , {
              error: stagedLastName && !validLastName,
              validationMessage: stagedLastName && !validLastName && I18n.text('userPreferences.labels.invalidName'),
              children: /*#__PURE__*/_jsx(TextInput, {
                "data-test-id": "blank-last-name",
                value: stagedLastName,
                onChange: this.props.onStagedLastNameChanged
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx(DialogFooter, {
        align: "center",
        children: /*#__PURE__*/_jsx(Button, {
          use: "primary",
          "data-test-id": "blank-save-name-btn",
          onClick: this.props.onSaveName,
          disabled: !validFirstName || !validLastName,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.labels.save"
          })
        })
      })]
    });
  }
}
BlankNameModal.propTypes = {
  stagedFirstName: PropTypes.string.isRequired,
  stagedLastName: PropTypes.string.isRequired,
  validFirstName: PropTypes.bool.isRequired,
  validLastName: PropTypes.bool.isRequired,
  onSaveName: PropTypes.func.isRequired,
  onStagedFirstNameChanged: PropTypes.func.isRequired,
  onStagedLastNameChanged: PropTypes.func.isRequired
};
export default BlankNameModal;